import React from 'react';
import svgPaths from "./svg-n7w9hotcin";
import SessionDropdown from '../components/SessionDropdown';
import LanguageDropdown from '../components/LanguageDropdown';

type BlockMenuProps = {
  briefStatus: string;
  onLogout: () => void;
};

export default function BlockMenu({ briefStatus, onLogout }: BlockMenuProps) {
  const isBriefUsable =
    briefStatus === 'Basic brief' ||
    briefStatus === 'Good brief' ||
    briefStatus === 'Complete brief';

  return (
    <div className="h-[88px] w-full overflow-clip relative border-b border-[#EDF0F5] flex items-center justify-between px-8">
      {/* Logo */}
      <div className="h-[24.114px] w-[159px] flex-shrink-0">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 159 25">
          <g>
            <path d={svgPaths.p31795600} fill="#212736" />
            <path d={svgPaths.p8ade500} fill="#212736" />
          </g>
        </svg>
      </div>
      {/* Center: language, session, and logout controls */}
      <div className="flex flex-row items-center gap-6 mx-auto">
        <LanguageDropdown />
        <SessionDropdown />
        <button
          onClick={onLogout}
          className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
          aria-label="Logout"
        >
          Logout
        </button>
      </div>
      {/* Right: Avatar and Use this brief button */}
      <div className="flex items-center gap-8 flex-shrink-0">
        <div className="bg-[#464c5c] rounded-[72px] size-10 flex items-center justify-center">
          <p className="font-bold text-[#f7f8fa] text-[16px]">DL</p>
        </div>
        <button
          className={`rounded-lg transition-colors duration-300 px-6 py-3 flex items-center gap-2 font-bold text-[16px] text-white ${
            isBriefUsable
              ? 'bg-[#165bfb] hover:bg-[#1246d7] active:bg-[#0d38b0] cursor-pointer'
              : 'bg-[#9ebbff] opacity-70 cursor-not-allowed'
          }`}
          disabled={!isBriefUsable}
          aria-label="Use this brief"
        >
          <span className="relative shrink-0 size-6">
            <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
              <g>
                <g>
                  <path d={svgPaths.p1fade100} fill="white" />
                  <path d={svgPaths.p230cf780} fill="white" />
                  <path d={svgPaths.p26295800} fill="white" />
                </g>
              </g>
            </svg>
          </span>
          Use this brief
        </button>
      </div>
    </div>
  );
}
